// Copyright (C) 2022 Cochise Ruhulessin
//
// All rights reserved. No warranty, explicit or implicit, provided. In
// no event shall the author(s) be liable for any claim or damages.
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
import { faXmark } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import './ContextPanelContainer.scss'
import { IonButton, IonButtons, IonContent, IonFooter, IonModal, IonToolbar } from "@ionic/react"
import { useContextMenu } from "./SectionContainer"
import useScreenSize from "./useScreenSize"
import { useLocales } from "react-localized"


interface ContextMenuContainerProps {
  children?: React.ReactNode
  isOpen: boolean
  title: string
  close?: () => void
}


const ContextMenuModal: React.FC<ContextMenuContainerProps> = (props) => {
  const panelCtx = useContextMenu()
  const {gettext} = useLocales()
  const {children, close, isOpen, title} = props
  return (
    <IonModal backdropDismiss={false} isOpen={true} className="context">
      <IonContent scrollY={false}>
        <div className="header">
          <h2>{title}</h2>
        </div>
        <div className="content">{children}</div>
      </IonContent>
      {(close !== undefined) ? (<IonFooter>
        <IonToolbar>
          <IonButton
            color="danger"
            fill="clear"
            onClick={close}
            style={{margin: "0px", width: "100%"}}
          >
            {gettext("Cancel")}
          </IonButton>
        </IonToolbar>
      </IonFooter>) : null}
    </IonModal>
  )
}


const ContextPanelElement: React.FC<ContextMenuContainerProps> = (props) => {
  const panelCtx = useContextMenu()
  const {children, close, isOpen, title} = props
  return (!isOpen) ? null : (
    <aside className="context">
      <div className="header">
        {(close === undefined) ? null : (<IonButton
          fill="clear"
          onClick={() => panelCtx.close()}
        >
          <span>
            <FontAwesomeIcon icon={faXmark} style={{height: "100%", width: "100%"}}/>
          </span>
        </IonButton>)}
        <h2 style={{marginLeft: (close === undefined) ? "11px" : "0px"}}>{title}</h2>
      </div>
      <div className="content">{children}</div>
    </aside>
  )
}


const ContextMenuContainer: React.FC<ContextMenuContainerProps> = (props) => {
  const isFullSize = useScreenSize()
  return (!!isFullSize) ? (<ContextPanelElement {...props}/>) : (<ContextMenuModal {...props}/>)
}


export type {ContextMenuContainerProps}
export {ContextMenuContainer}